import {Button as ChakraButton, ButtonProps} from "./ui/button";
import NextLink from "next/link";

const Button = ({href, children, ...props}: {href?: string} & ButtonProps) =>
  href ? (
    <ChakraButton asChild {...props}>
      <NextLink href={href}>{children}</NextLink>
    </ChakraButton>
  ) : (
    <ChakraButton {...props}>{children}</ChakraButton>
  );

export default Button;
